import React from 'react';

import { useFormContext } from 'react-hook-form';

import { Input, SeparatorLine, InputSectionGroup, ThemeModeToggle } from '@components';

type PreferencesProps = {
  isMobile: boolean;
};

const Preferences = React.forwardRef<HTMLElement, PreferencesProps>(function WrappedSection(
  { isMobile },
  ref,
) {
  const methods = useFormContext();

  return (
    <>
      <section className="py-8 flex flex-col" ref={ref}>
        <h2 className="text-sm md:text-xl pb-4 font-bold">Preferences</h2>
        <div className="w-full">
          <InputSectionGroup>
            <InputSectionGroup.Item>
              <div className="input-section-group__field">
                <label
                  className="input-section-group__label toggle__label"
                  htmlFor="email-notification"
                >
                  Receive Notifications Via Email
                </label>
                <div className="input-section-group__control flex items-center justify-end">
                  <Input
                    id="email-notification"
                    size="large"
                    type="checkbox"
                    {...methods.register('emailNotification')}
                    aria-label="Email notification"
                  />
                </div>
              </div>
              <div className="pt-2 text-sm text-gray-600 font-thin">
                Get notifications you may have missed to your email
              </div>
            </InputSectionGroup.Item>
          </InputSectionGroup>
        </div>
        <div className="mt-6">
          <ThemeModeToggle compact />
        </div>
      </section>

      <SeparatorLine />
    </>
  );
});

export default Preferences;
